export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/visual-cues-icon.svg?1c7fb255cef059f066abd7eaef800c6b";